import React, { PropTypes } from 'react';
import cn from 'classnames';
import { childrenShape } from '@bibliocommons/bc-prop-types';

import './Capsule.scss';

export default function Capsule({ className, children }) {
  return (
    <div className={cn('cp-capsule', className)}>
      {children}
    </div>
  );
}

Capsule.propTypes = {
  className: PropTypes.string,
  children: childrenShape
};



// WEBPACK FOOTER //
// ./app/components/borrowing/fines/Capsule/Capsule.jsx